import { render } from "./ViewedReleaseNote.vue?vue&type=template&id=ad192b30"
import script from "./ViewedReleaseNote.vue?vue&type=script&lang=js"
export * from "./ViewedReleaseNote.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__